import styled from "styled-components";

export default styled.div`
  .modal-dialog {
    justify-content: center;
  }
  .modal-content {
    border-radius: 24px;
    max-width: 390px;
  }
  .modal-header {
    padding-bottom: 0.5rem;
  }
  .connect-wallet-modal-body {
    padding: 2rem;
    padding-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    button {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      background-color: transparent;
      border-radius: 12px;
      padding: 5px 15px;
      border: 1px solid;
      font-size: 1.5rem;
      img {
        width: 25px;
        height: 25px;
      }
      span {
        width: 200px;
        text-align: start;
      }
    }
  }
  .modal-footer {
    display: flex;
    padding: 1rem;
    button {
      padding: 5px 10px;
      border-radius: 8px;
      border: 0;
      :first-child {
        color: #fff;
        background-color: #002c74;
      }
    }
  }
`;
